import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/browser";
import config from "./config.json";

import { PaymentModeReducer } from "./redux/reducers/changePayModeBusiness";
import { theme } from "./theme";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";

Sentry.init({
  dsn:
    config.env === "prod"
      ? "https://5309f8c710ae4dc1a3ec70e063fe2960@o323278.ingest.sentry.io/5390384"
      : "https://d877e3b424db42d3806b7ac333f192b3@o323278.ingest.sentry.io/5390933",
});

// Disable geolocation for the navigator object (can be explained why needed)
if (navigator.geolocation) {
  Object.defineProperty(navigator, "geolocation", {
    value: undefined,
    configurable: true,
    writable: true,
  });
}

const rootElement = document.getElementById("root");

const renderApp = ReactDOM[rootElement.hasChildNodes() ? "hydrate" : "render"];

renderApp(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  rootElement
);

// Service worker is left unregistered, with optional update logic commented out for future use
serviceWorker.unregister();
